import { Controller } from "@hotwired/stimulus";

import { patch, post } from "../lib/http.js";
import { showToast } from "../lib/toast.js";

/** Кнопка «На полку» на странице книги: добавление и смена статуса. */
export default class extends Controller {
  static targets = ["button", "dialog", "userBookId"];
  static values = { bookId: Number };

  open() {
    this.dialogTarget.showModal();
  }

  /**
   * Пункт списка статусов.
   *
   * Книга уже на полке — меняем статус, иначе добавляем: отличить одно от
   * другого позволяет сохранённый id записи полки.
   */
  async choose(event) {
    event.preventDefault();

    const { status } = event.currentTarget.dataset;
    if (!status) return;

    this.dialogTarget.close();
    const userBookId = this.userBookIdTarget.value;

    try {
      if (userBookId) {
        await patch(`/api/shelf/books/${userBookId}`, { status });
        this.buttonTarget.textContent = `На полке · ${event.currentTarget.textContent.trim()}`;
        showToast("Статус книги обновлён", "success");
        return;
      }

      const userBook = await post("/api/shelf/books", { book: this.bookIdValue, status });
      // Запоминаем запись полки: следующий выбор уже меняет статус.
      this.userBookIdTarget.value = userBook.pk;
      this.buttonTarget.textContent = `На полке · ${event.currentTarget.textContent.trim()}`;
      showToast("Книга добавлена на полку", "success");
    } catch (error) {
      showToast(error.message);
    }
  }
}
